import Paginator from "component/shared/Paginator/Paginator";
import Dropdown from "component/shared/dropdown/Dropdown";
import { EXTERNAL_TRADE_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
import {
  // Usage_Degrees,
  Usage_Degrees_ReportDisplayType,
  reportType,
} from "constants/Defaults";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import ChevronIcon from "svg-icons/chevron-icon";
import useSWR from "swr";
import { LabelLangString } from "component/LabelLang/label-lang";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Table } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import ReplayIcon from "@mui/icons-material/Replay";
import numberWithCommas from "functions/numericWithCommas";
import SnackbarModal from "component/shared/snackbar";
import ReactGA from "react-ga4";

const DegreeofUse = ({ yearMonthDate }) => {
  const intl = useIntl();
  const pdfImage = process.env.PUBLIC_URL + "/image/pdf.png";
  const excelImage = process.env.PUBLIC_URL + "/image/Excel.svg";
  const pdfHeader = process.env.PUBLIC_URL + "/image/pdfHeader.png";
  const pdfFooter = process.env.PUBLIC_URL + "/image/pdfFooter.png";
  const maxDate = new Date().toJSON().slice(0, 10);
  const dir = useSelector(({ theme }) => theme.direction);

  const currentLocale = useSelector(({ theme }) => theme.locale);

                        
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/external-trade", title: "Degree of use or Manufacture External Trade Page" });
  }, []);


  const defaultState = {
    ChapterDisplayType: null,
    id: null,
    ReportType: null,
    FromMonth: null,
    ToMonth: null,
    FromYear: null,
    ToYear: null,
    PageSize: 10,
    CurrentPage: 1,
  };

  const [filters, setFilters] = useState(defaultState);
  const [changeState, setChangeState] = useState(defaultState);
  const [changeCount, setChangeCount] = useState(defaultState);
  const [filterCount, setFilterCount] = useState(defaultState);

  const handelFilterData = (e) => {
    let filterData = { ...changeState };
    if (e.target.name === "FromDate") {
      filterData["FromMonth"] = e.target.value.slice(5, 7);
      filterData["FromYear"] = e.target.value.slice(0, 4);
    } else if (e.target.name === "ToDate") {
      filterData["ToMonth"] = e.target.value.slice(5, 7);
      filterData["ToYear"] = e.target.value.slice(0, 4);
    } else {
      filterData[e.target.name] = e.target.value;
    }
    setChangeState(filterData);

    let count = { ...changeCount };
    if (e.target.name === "FromDate") {
      count["FromMonth"] = e.target.value.slice(5, 7);
      count["FromYear"] = e.target.value.slice(0, 4);
    } else if (e.target.name === "ToDate") {
      count["ToMonth"] = e.target.value.slice(5, 7);
      count["ToYear"] = e.target.value.slice(0, 4);
    } else {
      count[e.target.name] = e.target.value;
    }
    setChangeCount(count);
  };

  const onPageIndexChange = (e, value) => {
    setFilters((prevState) => ({
      ...prevState,
      CurrentPage: value,
    }));
  };

  const reportFetching = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.USAGE}`,
    params: filters,
  });

  const usageDegrees = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.USAGE_LOOKUP}`,
  });
  const countFetching = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.USAGE}`,
    params: filterCount,
  });

  const [reportTypeInfo, setReportTypeInfo] = useState();
  const handelChangeReportType = (e) => {
    setReportTypeInfo(
      reportType.find((el) => +el.id === +changeState.ReportType)
    );
  };

  const [displayTypeInfo, setDisplayTypeInfo] = useState();
  const handelChangeDisplayType = (e) => {
    setDisplayTypeInfo(
      Usage_Degrees_ReportDisplayType.find(
        (el) => +el.id === +changeState.ChapterDisplayType
      )
    );
  };

  const [degreeInfo, setDegreeInfo] = useState();
  const handelChangeDegreeId = (e) => {
    setDegreeInfo(
      usageDegrees?.data?.data?.find((el) => +el.id === +changeState.id)
    );
  };

  const resetForm = () => {
    document.querySelectorAll("input").value = "";
    document.querySelectorAll("select").value = 0;
    setFilters(defaultState);
    setFilterCount(defaultState);
  };

  const elementPdf = useRef(null);
  const generateToPDF = useReactToPrint({
    documentTitle: `${
      dir === "rtl"
        ? "طبقا لدرجة الإستخدام والتصنيع"
        : "By degree of use or manufacture"
    } - ${LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: reportTypeInfo?.name,
      translations: reportTypeInfo?.translations,
    })} - ${LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: displayTypeInfo?.name,
      translations: displayTypeInfo?.translations,
    })} / ${LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: degreeInfo?.name,
      translations: degreeInfo?.translations,
    })} - ( ${filterCount.FromMonth}/${filterCount.FromYear} - ${
      filterCount.ToMonth
    }/${filterCount.ToYear} )`,
    content: () => elementPdf.current,
    bodyClass: `${dir === 'rtl' ? 'exportBody-rtl' : 'exportBody-ltr'}`
  });

  // error
  const [openError, setOpenError] = useState(false);
  const handleOpenError = () => {
      setOpenError(true);
  };
  const handleCloseError = () => {
      setOpenError(false);
  };

  const [alertEmptyData, setAlertEmptyData] = useState(false);
  const handleOpenAlert = () => {
      setAlertEmptyData(true);
  };
  const handleCloseAlert = () => {
      setAlertEmptyData(false);
  };

  return (
    <div className="active-item-news-tabs">
      <div className="browsetopic-box alls mb-0 py-3">
        <div className="container">
          <form
            className="row gy-3 align-items-center"
            onSubmit={(e) => {
              e.preventDefault();
              if(changeState.ChapterDisplayType && changeState.id && changeState.ReportType && changeState.FromMonth && changeState.FromYear && changeState.ToMonth && changeState.ToYear) {
                handleCloseAlert();
                if (new Date(`${+changeState.ToYear}-${+changeState.ToMonth}`) >= new Date(`${+changeState.FromYear}-${+changeState.FromMonth}`)) {
                  handelChangeDegreeId();
                  handelChangeReportType();
                  handelChangeDisplayType();
                  setFilters({ ...changeState });
                  setFilterCount({
                    ...changeCount,
                    PageSize: null,
                    CurrentPage: null,
                  });
                } else {
                  handleOpenError()
                }
              }
              else {
                handleOpenAlert();
              }
            }}
          >
            <div className="col-12 col-lg-6 ">
              <div className="item-form coll">
                <label htmlFor="ReportType">
                  <FormattedMessage id="statement-type" />
                </label>
              </div>
              <Dropdown
                item={reportType}
                name={"ReportType"}
                placeholder={intl.formatMessage({
                  id: "choose-statement-type",
                })}
                change={handelFilterData}
                required={true}
              />
            </div>
            <div className="col-12 col-lg-6 ">
              <div className="item-form coll">
                <label htmlFor="ChapterDisplayType">
                  <FormattedMessage id="display-type" />
                </label>
              </div>
              <Dropdown
                item={Usage_Degrees_ReportDisplayType}
                name={"ChapterDisplayType"}
                placeholder={intl.formatMessage({ id: "choose-display-type" })}
                change={handelFilterData}
                required={true}
              />
            </div>
            <div className="col-12 col-lg-6 ">
              <div className="item-form coll">
                <label htmlFor="FromDate">
                  <FormattedMessage id="fromDate" />
                </label>
                <input
                  name="FromDate"
                  id="FromDate"
                  onChange={handelFilterData}
                  type="month"
                  style={{ textAlign: dir === "rtl" ? "end" : "start" }}
                  min={
                    +changeState.ReportType === 1 ||
                    +changeState.ReportType === 0
                      ? `${+yearMonthDate?.importMinYear}-${
                          +yearMonthDate?.importMinMonth < 10
                            ? `0${+yearMonthDate?.importMinMonth}`
                            : +yearMonthDate?.importMinMonth
                        }`
                      : `${+yearMonthDate?.exportMinYear}-${
                          +yearMonthDate?.exportMinMonth < 10
                            ? `0${+yearMonthDate?.exportMinMonth}`
                            : +yearMonthDate?.exportMinMonth
                        }`
                  }
                  max={
                    +changeState.ReportType === 1 ||
                    +changeState.ReportType === 0
                      ? `${+yearMonthDate?.importMaxYear}-${
                          +yearMonthDate?.importMaxMonth < 10
                            ? `0${+yearMonthDate?.importMaxMonth}`
                            : +yearMonthDate?.importMaxMonth
                        }`
                      : `${+yearMonthDate?.exportMaxYear}-${
                          +yearMonthDate?.exportMaxMonth < 10
                            ? `0${+yearMonthDate?.exportMaxMonth}`
                            : +yearMonthDate?.exportMaxMonth
                        }`
                  }
                  className="form-control position-relative"
                  // required
                />
              </div>
            </div>
            <div className="col-12 col-lg-6 ">
              <div className="item-form coll">
                <label htmlFor="ToDate">
                  <FormattedMessage id="toDate" />
                </label>
                <input
                  name="ToDate"
                  id="ToDate"
                  onChange={handelFilterData}
                  type="month"
                  style={{ textAlign: dir === "rtl" ? "end" : "start" }}
                  min={
                    +changeState.ReportType === 1 ||
                    +changeState.ReportType === 0
                      ? `${+yearMonthDate?.importMinYear}-${
                          +yearMonthDate?.importMinMonth < 10
                            ? `0${+yearMonthDate?.importMinMonth}`
                            : +yearMonthDate?.importMinMonth
                        }`
                      : `${+yearMonthDate?.exportMinYear}-${
                          +yearMonthDate?.exportMinMonth < 10
                            ? `0${+yearMonthDate?.exportMinMonth}`
                            : +yearMonthDate?.exportMinMonth
                        }`
                  }
                  max={
                    +changeState.ReportType === 1 ||
                    +changeState.ReportType === 0
                      ? `${+yearMonthDate?.importMaxYear}-${
                          +yearMonthDate?.importMaxMonth < 10
                            ? `0${+yearMonthDate?.importMaxMonth}`
                            : +yearMonthDate?.importMaxMonth
                        }`
                      : `${+yearMonthDate?.exportMaxYear}-${
                          +yearMonthDate?.exportMaxMonth < 10
                            ? `0${+yearMonthDate?.exportMaxMonth}`
                            : +yearMonthDate?.exportMaxMonth
                        }`
                  }
                  className="form-control position-relative"
                  // required
                />
              </div>
            </div>
            <div className="col-12">
              <div className="item-form coll">
                <label htmlFor="id">
                  <FormattedMessage id="degree-of-use" />
                </label>
              </div>
              <Dropdown
                item={usageDegrees?.data?.data}
                name={"id"}
                placeholder={intl.formatMessage({ id: "choose-degree-of-use" })}
                change={handelFilterData}
                required={true}
              />
            </div>
            <div className="col-12 col-xl-3">
              <div className="text-white fw-bold my-3">
                <span>
                  <FormattedMessage id="allow-data" />
                </span>
                <span
                  className={`content h5 mb-0 fw-bold ${
                    dir === "rtl" ? "me-2" : "ms-2"
                  }`}
                  style={{ color: "var(--second-color)" }}
                >
                  {+changeState.ReportType === 1 ||
                  +changeState.ReportType === 0
                    ? `${+yearMonthDate?.importMaxYear}-${
                        +yearMonthDate?.importMaxMonth < 10
                          ? `0${+yearMonthDate?.importMaxMonth}`
                          : +yearMonthDate?.importMaxMonth
                      }`
                    : `${+yearMonthDate?.exportMaxYear}-${
                        +yearMonthDate?.exportMaxMonth < 10
                          ? `0${+yearMonthDate?.exportMaxMonth}`
                          : +yearMonthDate?.exportMaxMonth
                      }`}
                </span>
              </div>
            </div>
            <div className="col-12 col-xl-9 ">
              <div className="row align-items-center justify-content-end my-3">
                {countFetching?.data?.data?.items &&
                  Object.keys(countFetching?.data?.data?.items).length > 0 && (
                    <div className="col-lg-5 col-md-6 col-12">
                      <div className="text-white fw-bold">
                        <span>
                          <FormattedMessage id="download-data" />
                        </span>
                        <span
                          className={`content ${
                            dir === "rtl" ? "me-3" : "ms-3"
                          }`}
                        >
                          <span
                            className={`sp-icon ${
                              dir === "rtl" ? "ms-3" : "me-3"
                            }`}
                            onClick={() => {
                              generateToPDF();
                            }}
                          >
                            <img
                              src={pdfImage}
                              style={{
                                width: "40px",
                                cursor: "pointer",
                                borderRadius: "6px",
                              }}
                              alt="pdf-image"
                            />
                          </span>
                          <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className={`border-0 bg-transparent`}
                            table={`table-to-xls-country-degree-report`}
                            filename={`${
                              dir === "rtl"
                                ? "طبقا لدرجة الإستخدام والتصنيع"
                                : "By degree of use or manufacture"
                            } - ${LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: reportTypeInfo?.name,
                              translations: reportTypeInfo?.translations,
                            })} - ${LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: displayTypeInfo?.name,
                              translations: displayTypeInfo?.translations,
                            })} / ${LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: degreeInfo?.name,
                              translations: degreeInfo?.translations,
                            })} - ( ${filterCount.FromMonth}/${
                              filterCount.FromYear
                            } - ${filterCount.ToMonth}/${filterCount.ToYear} )`}
                            sheet="tablexls"
                            buttonText={
                              <span className="sp-icon">
                                <img
                                  src={excelImage}
                                  style={{
                                    width: "40px",
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                  }}
                                  alt="excel-image"
                                />
                              </span>
                            }
                          />
                        </span>
                      </div>
                    </div>
                  )}
                <div className="col-lg-7 col-md-6 col-12">
                  <div className="d-flex gap-2 mt-3 mt-md-0">
                    <button type="submit" className="main-btn">
                      <span>
                        <FormattedMessage id="view-data" />
                      </span>
                      <ChevronIcon width={12} height={12} />
                    </button>
                    <button
                      type="reset"
                      className="second-btn"
                      onClick={() => {
                        resetForm();
                      }}
                    >
                      <span>
                        <FormattedMessage id="reset" />
                      </span>
                      <ReplayIcon style={{ fontSize: 20 }} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* error */}
      <SnackbarModal open={openError} onClose={handleCloseError} severity="error" message={intl.formatMessage({
        id: "fromDate_ToDate_Role",
      })} />

      <SnackbarModal open={alertEmptyData} onClose={handleCloseAlert} severity="error" message={intl.formatMessage({
        id: "must_fill_all_fields",
      })} />

      <div className="body-news pt-4">
        {reportFetching?.isLoading ? (
          <h5 className="text-center" dir="ltr">
            <FormattedMessage id="loading..." />
          </h5>
        ) : reportFetching?.data?.data?.items && degreeInfo ? (
          Object.keys(reportFetching?.data?.data?.items).length > 0 ? (
            <>
              <Table responsive striped bordered hover className="text-center">
                <thead
                  className="text-white main-bg"
                >
                  <tr>
                    <th
                      colSpan={
                        +filters?.ChapterDisplayType === 4 || +filters?.ChapterDisplayType === 2
                          ? 3
                          : +filters.ChapterDisplayType === 1
                          ? 7
                          : 4
                      }
                    >
                      {LabelLangString({
                        id: "name",
                        currentLocale: currentLocale,
                        defaultValue: reportTypeInfo?.name,
                        translations: reportTypeInfo?.translations,
                      })}{" "}
                      -{" "}
                      {LabelLangString({
                        id: "name",
                        currentLocale: currentLocale,
                        defaultValue: displayTypeInfo?.name,
                        translations: displayTypeInfo?.translations,
                      })}{" "}
                      -{" "}
                      {dir === "rtl"
                        ? "طبقا لدرجة الإستخدام والتصنيع"
                        : "By degree of use or manufacture"
                      }
                    </th>
                  </tr>
                  <tr>
                    <th
                      colSpan={
                        +filters?.ChapterDisplayType === 4 || +filters?.ChapterDisplayType === 2
                          ? 3
                          : +filters.ChapterDisplayType === 1
                          ? 7
                          : 4
                      }
                    >
                      {LabelLangString({
                        id: "name",
                        currentLocale: currentLocale,
                        defaultValue: degreeInfo?.name,
                        translations: degreeInfo?.translations,
                      })}{" "}
                      -- ( <FormattedMessage id="period-from" />{" "}
                      {`${filters.FromMonth}/${filters.FromYear}`} -{" "}
                      <FormattedMessage id="to" />{" "}
                      {`${filters.ToMonth}/${filters.ToYear}`} )
                    </th>
                  </tr>
                  <tr>
                    <th
                      colSpan={
                        +filters?.ChapterDisplayType === 4 || +filters?.ChapterDisplayType === 2
                          ? 3
                          : +filters.ChapterDisplayType === 1
                          ? 7
                          : 4
                      }
                    >
                      {intl.formatMessage({
                        id: "quantity-data-under-constraction",
                      })}
                    </th>
                  </tr>
                  <tr>
                    <th style={{ width: "30%" }}>
                      {intl.formatMessage({
                        id: `${
                          reportFetching?.data?.data?.items[0]?.country
                            ? "country"
                            : reportFetching?.data?.data?.items[0]?.item
                            ? "item"
                            : reportFetching?.data?.data?.items[0]?.chapter
                            ? "chapter"
                            : reportFetching?.data?.data?.items[0]?.subChapter
                            ? "sub-chapter"
                            : reportFetching?.data?.data?.items[0]?.year
                            ? "year"
                            : "country"
                        }`,
                      })}
                    </th>
                    {+filters?.ChapterDisplayType !== 4 && +filters.ChapterDisplayType !== 2 && (
                      <th>
                        {intl.formatMessage({
                          id: `${
                            reportFetching?.data?.data?.items[0]?.country
                              ? "country-code"
                              : reportFetching?.data?.data?.items[0]?.item
                              ? "item-code"
                              : reportFetching?.data?.data?.items[0]?.chapter
                              ? "chapter-code"
                              : reportFetching?.data?.data?.items[0]?.subChapter
                              ? "sub-chapter-code"
                              : reportFetching?.data?.data?.items[0]?.year
                              ? "-"
                              : "country-code"
                          }`,
                        })}
                      </th>
                    )}
                    {+filters?.ChapterDisplayType === 1 ? (
                      <th>{intl.formatMessage({ id: "unit" })}</th>
                    ) : (
                      ""
                    )}
                    <th>{intl.formatMessage({ id: "pound-value" })}</th>
                    <th>{intl.formatMessage({ id: "dollar-value" })}</th>
                    {+filters?.ChapterDisplayType === 1 ? (
                      <>
                        <th>{intl.formatMessage({ id: "quantity" })}</th>
                        <th>{intl.formatMessage({ id: "quantity-number" })}</th>
                      </>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {+countFetching?.data?.data?.totals?.egTotals > 0 &&
                    +countFetching?.data?.data?.totals?.usdTotals > 0 && (
                      <tr>
                        <td>{intl.formatMessage({ id: "totaly" })}</td>
                        {+filters?.ChapterDisplayType !== 4 && +filters.ChapterDisplayType !== 2 && <td></td>}
                        <td>
                          {numberWithCommas(
                              countFetching?.data?.data?.totals?.egTotals?.toFixed(2)
                            )
                          }
                        </td>
                        <td>
                          {numberWithCommas(
                              countFetching?.data?.data?.totals?.usdTotals?.toFixed(2)
                            )
                          }
                        </td>
                        {+filters?.ChapterDisplayType > 5 && <td></td>}
                        {+filters?.ChapterDisplayType === 1 ? <>
                          <td></td>
                          <td></td>
                        </> : ""}
                      </tr>
                    )}
                  <Paginator
                    size={filters.PageSize}
                    table={true}
                    colspan={
                      +filters?.ChapterDisplayType === 4 || +filters?.ChapterDisplayType === 2
                        ? 3
                        : +filters.ChapterDisplayType === 1
                        ? 7
                        : 4
                    }
                    change={onPageIndexChange}
                    page={filters.CurrentPage}
                    totalCount={reportFetching?.data?.data?.pager?.totalCount}
                  >
                    {reportFetching?.data?.data?.items.map(
                      (
                        {
                          country,
                          item,
                          chapter,
                          subChapter,
                          year,
                          // measure_Units,
                          quantity,
                          quantityInNumber,
                          valueEGP,
                          valueUSD,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td>
                            {year
                              ? year
                              : LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: country
                                    ? country?.name
                                    : item
                                    ? item?.name
                                    : chapter
                                    ? chapter?.name
                                    : subChapter
                                    ? subChapter?.name
                                    : "",
                                  translations: country
                                    ? country?.translations
                                    : item
                                    ? item?.translations
                                    : chapter
                                    ? chapter?.translations
                                    : subChapter
                                    ? subChapter?.translations
                                    : [],
                                })}
                          </td>
                          {+filters?.ChapterDisplayType !== 4 && +filters.ChapterDisplayType !== 2 && (
                            <td>
                              {country ? (
                                country?.code
                              ) : item ? (
                                item?.hsn
                              ) : chapter ? (
                                chapter?.code
                              ) : subChapter ? (
                                subChapter?.code
                              ) : (
                                <mark
                                  className="rounded text-white p-1 second-bg"
                                >
                                  N/A
                                </mark>
                              )}
                            </td>
                          )}
                          {+filters?.ChapterDisplayType === 1 ? (
                            <td>
                              {LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: item?.measure_Units
                                  ? item?.measure_Units?.name
                                  : "N/A",
                                translations: item?.measure_Units
                                  ? item?.measure_Units?.translations
                                  : [],
                              })}
                            </td>
                          ) : (
                            ""
                          )}
                          <td>{numberWithCommas(valueEGP.toFixed(2))}</td>
                          <td>{numberWithCommas(valueUSD.toFixed(2))}</td>
                          {+filters?.ChapterDisplayType === 1 ? <>
                            <td>{numberWithCommas(quantity.toFixed(2))}</td>
                            <td>
                              {numberWithCommas(quantityInNumber?.toFixed(2))}
                            </td>
                          </> : ""}
                        </tr>
                      )
                    )}
                  </Paginator>
                </tbody>
              </Table>

              <div className="d-none">
                <div ref={elementPdf}>
                  <img
                    src={pdfHeader}
                    alt="pdf-header"
                    className="w-100"
                    style={{
                      // position: "fixed",
                      top: "5px",
                      left: 1,
                      zIndex: 100000,
                    }}
                  />
                  <Table
                    responsive
                    striped
                    bordered
                    hover
                    className="text-center"
                    id={`table-to-xls-country-degree-report`}
                  >
                    <thead
                      className="text-white main-bg"
                      
                    >
                      <tr>
                        <th
                          colSpan={
                            +filterCount?.ChapterDisplayType === 4 || +filterCount?.ChapterDisplayType === 2
                              ? 3
                              : +filterCount.ChapterDisplayType === 1
                              ? 7
                              : 4
                          }
                        >
                          {maxDate}
                        </th>
                      </tr>
                      <tr>
                        <th
                          colSpan={
                            +filterCount?.ChapterDisplayType === 4 || +filterCount?.ChapterDisplayType === 2
                              ? 3
                              : +filterCount.ChapterDisplayType === 1
                              ? 7
                              : 4
                          }
                        >
                          {LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: reportTypeInfo?.name,
                            translations: reportTypeInfo?.translations,
                          })}{" "}
                          -{" "}
                          {LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: displayTypeInfo?.name,
                            translations: displayTypeInfo?.translations,
                          })}{" "}
                          -{" "}
                          {dir === "rtl"
                            ? "طبقا لدرجة الإستخدام والتصنيع"
                            : "By degree of use or manufacture"
                          }
                        </th>
                      </tr>
                      <tr>
                        <th
                          colSpan={
                            +filterCount?.ChapterDisplayType === 4 || +filterCount?.ChapterDisplayType === 2
                              ? 3
                              : +filterCount.ChapterDisplayType === 1
                              ? 7
                              : 4
                          }
                        >
                          {intl.formatMessage({
                            id: "quantity-data-under-constraction",
                          })}
                        </th>
                      </tr>
                      <tr>
                        <th
                          colSpan={
                            +filterCount?.ChapterDisplayType === 4 || +filterCount?.ChapterDisplayType === 2
                              ? 3
                              : +filterCount.ChapterDisplayType === 1
                              ? 7
                              : 4
                          }
                        >
                          {LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: degreeInfo?.name,
                            translations: degreeInfo?.translations,
                          })}{" "}
                          - ( <FormattedMessage id="period-from" />{" "}
                          {`${filterCount.FromMonth}/${filterCount.FromYear}`} -{" "}
                          <FormattedMessage id="to" />{" "}
                          {`${filterCount.ToMonth}/${filterCount.ToYear}`} )
                        </th>
                      </tr>
                      <tr>
                        <th style={{ width: "30%" }}>
                          {intl.formatMessage({
                            id: `${
                              countFetching?.data?.data?.items[0]?.country
                                ? "country"
                                : countFetching?.data?.data?.items[0]?.item
                                ? "item"
                                : countFetching?.data?.data?.items[0]?.chapter
                                ? "chapter"
                                : countFetching?.data?.data?.items[0]?.subChapter
                                ? "sub-chapter"
                                : countFetching?.data?.data?.items[0]?.year
                                ? "year"
                                : "country"
                            }`,
                          })}
                        </th>
                        {+filterCount?.ChapterDisplayType !== 4 && +filterCount?.ChapterDisplayType !== 2 && (
                          <th>
                            {intl.formatMessage({
                              id: `${
                                countFetching?.data?.data?.items[0]?.country
                                  ? "country-code"
                                  : countFetching?.data?.data?.items[0]?.item
                                  ? "item-code"
                                  : countFetching?.data?.data?.items[0]?.chapter
                                  ? "chapter-code"
                                  : countFetching?.data?.data?.items[0]
                                      ?.subChapter
                                  ? "sub-chapter-code"
                                  : countFetching?.data?.data?.items[0]?.year
                                  ? "-"
                                  : "country-code"
                              }`,
                            })}
                          </th>
                        )}
                        {+filterCount?.ChapterDisplayType === 1 ? (
                          <th>{intl.formatMessage({ id: "unit" })}</th>
                        ) : (
                          ""
                        )}
                        <th>{intl.formatMessage({ id: "pound-value" })}</th>
                        <th>{intl.formatMessage({ id: "dollar-value" })}</th>
                        {+filterCount?.ChapterDisplayType === 1 ? (
                          <>
                            <th>{intl.formatMessage({ id: "quantity" })}</th>
                            <th>{intl.formatMessage({ id: "quantity-number" })}</th>
                          </>
                        ) : (
                          ""
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {+countFetching?.data?.data?.totals?.egTotals > 0 &&
                        +countFetching?.data?.data?.totals?.usdTotals > 0 && (
                          <tr>
                            <td>{intl.formatMessage({ id: "totaly" })}</td>
                            {+filterCount?.ChapterDisplayType !== 4 && +filterCount?.ChapterDisplayType !== 2 && <td></td>}
                            <td>
                              {numberWithCommas(
                                  countFetching?.data?.data?.totals?.egTotals?.toFixed(2)
                                )
                              }
                            </td>
                            <td>
                              {numberWithCommas(
                                  countFetching?.data?.data?.totals?.usdTotals?.toFixed(2)
                                )
                              }
                            </td>
                            {+filterCount?.ChapterDisplayType > 5 && <td></td>}
                            {+filterCount?.ChapterDisplayType === 1 ? <>
                              <td></td>
                              <td></td>
                            </> : ""}
                          </tr>
                        )}
                      {countFetching?.data?.data?.items.map(
                        (
                          {
                            country,
                            item,
                            chapter,
                            subChapter,
                            year,
                            // measure_Units,
                            quantity,
                            quantityInNumber,
                            valueEGP,
                            valueUSD,
                          },
                          i
                        ) => (
                          <tr key={i}>
                            <td>
                              {year
                                ? year
                                : LabelLangString({
                                    id: "name",
                                    currentLocale: currentLocale,
                                    defaultValue: country
                                      ? country?.name
                                      : item
                                      ? item?.name
                                      : chapter
                                      ? chapter?.name
                                      : subChapter
                                      ? subChapter?.name
                                      : "",
                                    translations: country
                                      ? country?.translations
                                      : item
                                      ? item?.translations
                                      : chapter
                                      ? chapter?.translations
                                      : subChapter
                                      ? subChapter?.translations
                                      : [],
                                  })}
                            </td>
                            {+filterCount?.ChapterDisplayType !== 4 && +filterCount?.ChapterDisplayType !== 2 && (
                              <td>
                                {country ? (
                                  country?.code
                                ) : item ? (
                                  item?.hsn
                                ) : chapter ? (
                                  chapter?.code
                                ) : subChapter ? (
                                  subChapter?.code
                                ) : (
                                  <mark
                                    className="rounded text-white p-1 second-bg"
                                  >
                                    N/A
                                  </mark>
                                )}
                              </td>
                            )}
                            {+filterCount?.ChapterDisplayType === 1 ? (
                              <td>
                                {LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: item?.measure_Units
                                  ? item?.measure_Units?.name
                                  : "N/A",
                                translations: item?.measure_Units
                                  ? item?.measure_Units?.translations
                                    : [],
                                })}
                              </td>
                            ) : (
                              ""
                            )}
                            <td>{numberWithCommas(valueEGP?.toFixed(2))}</td>
                            <td>{numberWithCommas(valueUSD?.toFixed(2))}</td>
                            {+filterCount?.ChapterDisplayType === 1 ? <>
                              <td>{numberWithCommas(quantity?.toFixed(2))}</td>
                              <td>
                                {numberWithCommas(quantityInNumber?.toFixed(2))}
                              </td>
                            </> : ""}
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                  <img
                    src={pdfFooter}
                    alt="pdf-footer"
                    className="w-100"
                    style={{
                      // position: "fixed",
                      bottom: "10px",
                      left: 1,
                      zIndex: 100000,
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            <h4 className="text-center">
              <FormattedMessage id="data-not-found" />
            </h4>
          )
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default DegreeofUse;
